import type { ScannerProfile, ScannerSetting } from '@rtkwlf/rendall';

import type { ScannerDetailsForm } from '../scanners-config/components/types';

const getScannerSetting = (
  settingName: string,
  settings: Array<ScannerSetting>,
): boolean =>
  settings.filter((set) => set.name === settingName)[0]?.enabled || false;

export const transformToScannerDetailsForm = (
  scanner: ScannerProfile,
): ScannerDetailsForm => {
  const { scannerDetails } = scanner;
  return {
    deviceType: scanner.type,
    model: scanner.model,
    name: scanner.name,
    uuid: scanner?.uuid ?? '',
    version: scannerDetails?.version ?? '',
    vulnScan: getScannerSetting(
      'vulnerabilityScans',
      scannerDetails?.settings ?? [],
    ),
    bruteScan: getScannerSetting(
      'bruteForceChecks',
      scannerDetails?.settings ?? [],
    ),
    cgiScan: getScannerSetting('CGIScanning', scannerDetails?.settings || []),
    hostIden: getScannerSetting(
      'hostIdentificationScans',
      scannerDetails?.settings ?? [],
    ),
    pingOnly: getScannerSetting(
      'onlyPingTheTarget',
      scannerDetails?.settings ?? [],
    ),
    hostIdentificationScanIntensity:
      scannerDetails?.hostIdentificationScanIntensity ?? 'low',
    hostIdentificationScanPeriod: String(
      scannerDetails?.hostIdentificationScanPeriod ?? '5',
    ),
    maxConcurrentVulnerabilityScans: String(
      scannerDetails?.maxConcurrentVulnerabilityScans ?? '0',
    ),
    lastScanCompletion: scannerDetails?.lastOpenVASScanTimestamp ?? '',
    gateway: scanner?.networkConfiguration?.gateway ?? '',
    site: scanner.siteUuid ?? '',
  };
};
